module.exports = "/_next/static/images/more_publish-updates-f80947521cc2f4d9cb042de622dbf84b.jpg";